module.exports = __webpack_public_path__ + "static/media/tiled-yellow-card.64097e2c.png";